/**
 * @author Falk Brueckner <fabr@fabid.de>
 */

import { incomeList, IOccupation, timeList, usageList } from '../components/LoanCalculator/LoanUserDetails';
import IHome from '../interfaces/IHome';
import { ILoanOffer } from './BaufiSmartApi';
import Config from './Config';
import PropApiRequest from './PropApiRequest';

const loanApiUrl = Config.get('loanApi.url');

export interface ILoanRequestLoanCalculator {
    // showClosingCostsDetails?: string;
    // showEquityDetails?: string;
    price?: number;
    closingCostsPercentage?: number;
    stampDutyPercentage?: number;
    notarialCostsPercentage?: number;
    landRegisterCostsPercentage?: number;
    findersFeePercentage?: number;
    amortizationRatePercentage?: number;
    fixedInterestRateYears?: number;
    equity?: number;
    equityBank?: number;
    equityStock?: number;
    equityBuildingSociety?: number;
    equityAssurence?: number;
    equityMiscellaneous?: number;
}

export interface ILoanRequestChooseBank {
    occupation?: string;
    income?: string;
    banks?: string[];
}

export interface ILoanRequestUserData {
    given_name?: string;
    family_name?: string;
    address_line1?: string;
    postal_code?: string;
    locality?: string;
    phone?: string;
    mail?: string;
    dataProcessingAccepted?: boolean;
}
export interface ILoanRequestLoanDetails {
    occupation?: IOccupation;
    income?: keyof typeof incomeList;
    usage?: keyof typeof usageList;
    time?: keyof typeof timeList;
}

export interface ILoanRequestAddSubmit {
    id?: string;
    propertyId?: string;
    property?: IHome;
    loanCalculator?: ILoanRequestLoanCalculator;
    // chooseBank?: ILoanRequestChooseBank;
    offer?: ILoanOffer;
    userData?: ILoanRequestUserData;
    loanDetails?: ILoanRequestLoanDetails;
    provider: string;
    baufiLeadId?: string;
}

export interface ILoanRequestAdd {
    id: string;
}

class LoanRequest {
    public add = (data: ILoanRequestAddSubmit): Promise<ILoanRequestAdd> => {
        return PropApiRequest.postRequest(loanApiUrl + '/add?_format=json', data)
            .then((res) => {
                return res.getData() as ILoanRequestAdd;
            })
            .catch((e) => {
                console.error(e);
                return Promise.reject(e);
            });
    };
}

export default new LoanRequest();
